"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[640],{

/***/ 3987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./components/big/Navigation.jsx





var Navigation = function(param) {
    var titleData = param.titleData;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), conNavbar = ref[0], setConNavbar = ref[1];
    (0,react.useEffect)(function() {
        var onScroll = function onScroll() {
            if (window.scrollY >= 80) {
                setConNavbar(true);
            } else {
                setConNavbar(false);
            }
        };
        window.addEventListener("scroll", onScroll);
        return function() {
            window.removeEventListener("scroll", onScroll);
        };
    }, [
        conNavbar
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: conNavbar ? "navbar navbar-expand-lg bg-primary navbar-dark navbar-darkk fixed-top" : "navbar navbar-expand-lg bg-primary navbar-dark fixed-top",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "navbar-brand",
                    href: "#",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: titleData.titleWeb,
                        alt: "",
                        width: "106",
                        height: "50"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "navbar-toggler",
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": "#navbarColor01",
                    "aria-controls": "navbarColor01",
                    "aria-expanded": "false",
                    "aria-label": "Toggle navigation",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "navbar-toggler-icon"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "collapse navbar-collapse",
                    id: "navbarColor01",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "navbar-nav ms-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "nav-item",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: router.pathname === "/" ? "nav-link active" : "nav-link",
                                            href: "#",
                                            children: [
                                                "Beranda",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "visually-hidden",
                                                    children: "(current)"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "nav-item",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/produk",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: router.pathname === "/produk" ? "nav-link active" : "nav-link",
                                            children: "Produk"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "nav-item",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/about",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: router.pathname === "/about" ? "nav-link active" : "nav-link",
                                            children: "Tentang Kami"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "nav-item",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/#contact",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: router.pathname === "/#contact" ? "nav-link active" : "nav-link",
                                            children: "kontak"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "nav-item me-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/artikel",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: router.pathname === "/artikel" ? "nav-link active" : "nav-link",
                                            children: "Artikel"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/#contact",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "btn btn-warning my-2 my-sm-0 text-black",
                                type: "submit",
                                children: "Pesan Sekarang!!"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var big_Navigation = (Navigation);

;// CONCATENATED MODULE: ./components/big/Footer.jsx
/* eslint-disable react/no-unescaped-entities */ 


var Footer = function(param) {
    var titleData = param.titleData, dataOrmas = param.dataOrmas;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "footer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
            className: "bg-secondary pt-5 pb-3",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-md-6 text-white",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "fw-bold",
                                    children: titleData.judulFooter
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "fs-6",
                                    style: {
                                        marginBottom: "0.2rem"
                                    },
                                    children: titleData.alamat
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "fs-6",
                                    style: {
                                        marginBottom: "0.2rem"
                                    },
                                    children: [
                                        "Email : ",
                                        titleData.email
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "fs-6",
                                    style: {
                                        marginBottom: "0.2rem"
                                    },
                                    children: [
                                        "Telp / WA : ",
                                        titleData.wa
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "fs-6 mt-2 text-muted",
                                    style: {
                                        marginBottom: "0.2rem"
                                    },
                                    children: [
                                        "@ 2022 - ",
                                        titleData.nameProduk,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        titleData.end
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-md-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "fw-bold text-light",
                                    children: titleData.nameProduk
                                }),
                                dataOrmas.map(function(ormas) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-inline me-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: ormas.pictureRelasi,
                                            width: "60",
                                            height: "60",
                                            alt: ""
                                        })
                                    }, ormas._id);
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var big_Footer = (Footer);

;// CONCATENATED MODULE: ./components/Layout.jsx





var Layout = function(param) {
    var titlePage = param.titlePage, children = param.children, _titleData = param.titleData, titleData = _titleData === void 0 ? {} : _titleData, _dataOrmas = param.dataOrmas, dataOrmas = _dataOrmas === void 0 ? {} : _dataOrmas;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: titlePage && "".concat(titlePage, " - ").concat(titleData === null || titleData === void 0 ? void 0 : titleData.nameProduk)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: titleData.titleLogo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: titleData === null || titleData === void 0 ? void 0 : titleData.deskripsiSumber
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "Muchamad Aqmal Hidayat"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "air almasoem, PT. Muawana Al Masoem, air al masoem, air al ma'soem, al masoem, air minum al masoem, airalmasoem, ai almaseom,PT. Muawanah Al Ma'soem, Air Al Masoem, pesan air al maseom, loker al masoem,pt muawanah al ma'soem,pt masoem,pt almasoem,pt al ma'soem, gaji di pt al ma'soem, air mineral al masoem"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.airalmasoem.com/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: titleData.titleLogo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: titleData === null || titleData === void 0 ? void 0 : titleData.nameProduk
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(big_Navigation, {
                        titleData: titleData
                    }),
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(big_Footer, {
                        titleData: titleData,
                        dataOrmas: dataOrmas
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Layout = (Layout);


/***/ }),

/***/ 6765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap_Carousel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7255);
/* eslint-disable @next/next/no-img-element */ 


var CarouselPc = function(param) {
    var bannerDataPc = param.bannerDataPc;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: {
            marginTop: 68
        },
        className: "carouselPc",
        children: bannerDataPc.length == 1 ? bannerDataPc.map(function(bp, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                className: "d-block w-100",
                src: bp.gambarBanner,
                alt: "First slide"
            }, index);
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Carousel__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            fade: true,
            children: bannerDataPc.map(function(bp, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Carousel__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Item */ .Z.Item, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "d-block w-100",
                        src: bp.gambarBanner,
                        alt: "First slide"
                    })
                }, index);
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CarouselPc);


/***/ }),

/***/ 8433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap_Carousel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7255);



var CarouselMobile = function(param) {
    var bannerDataMobile = param.bannerDataMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: {
            marginTop: 68
        },
        className: "carouselMobile",
        children: bannerDataMobile.length == 1 ? bannerDataMobile.map(function(bp, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                className: "d-block w-100",
                src: bp.gambarBanner,
                alt: "First slide"
            }, index);
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Carousel__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            fade: true,
            children: bannerDataMobile.map(function(bp, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Carousel__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Item */ .Z.Item, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "d-block w-100",
                        src: bp.gambarBanner,
                        alt: "First slide"
                    })
                }, index);
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CarouselMobile);


/***/ }),

/***/ 3787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5005);
/* harmony import */ var react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9449);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2739);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);










var ProductCarousel = function(param) {
    var productData = param.productData;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), show = ref[0], setShow = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), name = ref1[0], setname = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), picture = ref2[0], setpicture = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), deskripsi = ref3[0], setdeskripsi = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), harga = ref4[0], setharga = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), satuanBeli = ref5[0], setsatuanBeli = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), qtyProduk = ref6[0], setqtyProduk = ref6[1];
    var handleClose = function() {
        return setShow(false);
    };
    var handleShow = function(product) {
        setShow(true);
        setname(product.name);
        setpicture(product.productPicture);
        setharga(product.harga);
        setdeskripsi(product.deskripsiProduct);
        setsatuanBeli(product.satuanBeli);
        setqtyProduk(product.qtyProduk);
    };
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var settings = {
        slidesToShow: 6,
        slidesToScroll: 1,
        cssEase: "linear",
        infinite: true,
        responsive: [
            {
                breakpoint: 1327,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    cssEase: "linear"
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    cssEase: "linear"
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    dots: true,
                    infinite: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    infinite: true
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row justify-content-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, settings), {
                    children: productData.map(function(product) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "card col-lg-4 produkPointer",
                            onClick: router.pathname !== "/produk" ? handleClose : function() {
                                return handleShow(product);
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: product.productPicture,
                                    className: "card-img-top",
                                    alt: "..."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "card-body text-white text-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                        className: router.pathname !== "/produk" ? "card-title" : "card-title text-black",
                                        children: product.name
                                    })
                                })
                            ]
                        }, product._id);
                    })
                }))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                show: show,
                onHide: handleClose,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Header */ .Z.Header, {
                        closeButton: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Title */ .Z.Title, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-black",
                                children: name
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Body */ .Z.Body, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("center", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: picture,
                                    alt: "",
                                    width: 300
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("table", {
                                className: "text-black mb-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: "Ukuran"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: " : "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: "Satuan Beli"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: " : "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: satuanBeli
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: "Quantity per beli"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: " : "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    children: qtyProduk
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-black",
                                children: deskripsi
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Footer */ .Z.Footer, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("center", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                variant: "primary",
                                onClick: handleClose,
                                children: "Tutup"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCarousel);


/***/ })

}]);